import $ from 'jquery';
import formHelper from 'formhelper';

const MODE_SINGLE_TICKETS = 'single-tickets';
const MODE_NFS_PACKAGE    = 'nfs-package';
const MODE_FIXED_PACKAGE  = 'fixed-package';
const MODE_RENEWALS_CHANGE_PACKAGE  = 'renewals-change-package';

const MODULE_SINGLE_TICKETS = 'single_tickets';
const MODULE_NFS_PACKAGE    = 'packages_nfs';
const MODULE_FIXED_PACKAGE  = 'packages_fixed';
const MODULE_RENEWALS  = 'renewals';

let currData;
let arePricetypesVisible = false;
let isSingleZone = false;
let isFixedPricetypeQuantities = false; // NFS in progress

function showDialogBuyTickets(data) {
  currData = data;
  arePricetypesVisible = false;

  let module;
  switch (data['buy-tickets-mode']) {
    case MODE_FIXED_PACKAGE:
      module = MODULE_FIXED_PACKAGE;
      break;
    case MODE_NFS_PACKAGE:
      module = MODULE_NFS_PACKAGE;
      break;
    case MODE_RENEWALS_CHANGE_PACKAGE:
      module = MODULE_RENEWALS;
      break;
    default:
      module = MODULE_SINGLE_TICKETS;
      break;
  }

  const autoReserve = !!data['auto-reserve'];
  const pathBase = `/h/${module}`;

  const purchaseTitle = data.title || 'Purchase Tickets';

  if (autoReserve) {
    lDialog.open({
      className: 'l-dialog--sectioned',
      title: '&nbsp;',
      content: lDialog.messages.spinning
    });

    $.ajax(pathBase + '/AttemptAutoReserveTickets', {
      data,
      success(data) {

        switch (data.status) {
          case 'SUCCESS':
            lDialog.open({
              title: '&nbsp;',
              content: lDialog.messages.takingToCart
            });
            window.setTimeout(function() {
              window.location.href = '/cart';
            }, 0);
            break;

          case 'ERROR': // failed, unable to return HTML
            delete currData['auto-reserve'];
            showDialogBuyTickets(currData);
            break;

          default: // HTML Response
            lDialog.open({
              title: purchaseTitle,
              className: 'l-dialog--sectioned',
              autofocusFirstFocusableElement: false,
              content: data
            });

            window.setTimeout(initDialogContents, 0);
        }
      }
    });

  } else {
    lDialog.open({
      title: purchaseTitle,
      className: 'l-dialog--sectioned',
      autofocusFirstFocusableElement: false,
      ajax: {
        url: pathBase + '/ShowDialogBuyTickets',
        data,
        error: lDialog.showGeneralError,
        success() {
          window.setTimeout(initDialogContents, 0);
        }
      }
    });
  }

}
$(document).on('click', '.js-dialog-buy-tickets', handleEvent);

// I don't want to retain references to any of these elements so I'm always scooping the dom
function $zonePricetypeContainers() {
  return $('.js-dialog-buy-tickets--zone-pricetypes-container');
}
function $selectZone(containingEl = document) {
  return $(containingEl).find('.js-dialog-buy-tickets--select-zone');
}
function $selectsPricetypes(containingEl = document) {
  return $(containingEl).find('.js-dialog-buy-tickets--select-zone-pricetype-qty');
}
function $currentPricetypeSelects() {
  if (isSingleZone) {
    return $selectsPricetypes();
  } else {
    const zone = $selectZone().val();
    if (zone === '') {
      return $();
    } else {
      const $zone = $zonePricetypeContainers().filter(`[data-zone-no="${zone}"]`);
      return $selectsPricetypes($zone);
    }
  }
}

function initDialogContents() {
  $('.js-dialog-buy-tickets--select-perf').one('change', onSelectPerfChange);

  const $zone = $selectZone();
  isSingleZone = $zone.length === 0;
  if (isSingleZone === false) {
    $zone.on('change', onSelectZoneChange);
  }

  const $pricetypes = $selectsPricetypes();
  isFixedPricetypeQuantities = $pricetypes.length === 0;
  if (isFixedPricetypeQuantities === false) {
    $pricetypes.on('change', updateBtnSubmitState);
  }

  const $btnShowPromo = $('#dialog-buy-tickets--btn-show-promo-entry');
  $btnShowPromo.one('click', _ => {
    $('#dialog-buy-tickets--section-enter-promo-code').show();
    $btnShowPromo.remove();
    window.setTimeout(_ => {
      $('#dialog-buy-tickets--input-promo-code').focus();
    }, 1)
  });
}

function getNumSelectedTickets() {
  return $currentPricetypeSelects()
      .toArray()
      .reduce((prev, el) => prev + parseInt($(el).val(), 10), 0);
}

function updateBtnSubmitState() {
  const $btnContainer = $('#btn--dialog-buy-tickets--ba-submit-container');
  let isEnabled;
  if (isFixedPricetypeQuantities) {
    isEnabled = $selectZone().val() !== '';
  } else {
    isEnabled = getNumSelectedTickets() > 0;
  }
  $btnContainer.toggle(isEnabled);
}

function onSelectPerfChange(event) {
  const $select = $(event.currentTarget);
  const type = $select.attr('data-buy-tickets-mode');
  const value = $select.val();
  const data = {};

  switch (type) {
    case MODE_NFS_PACKAGE:
      data.pkg_no = value;
      break;
    case MODE_FIXED_PACKAGE:
      data.pkg_no = value;
      break;
    default:
      data.perf_no = value;
      break;
  }

  reloadDialog(data);
}

function onSelectZoneChange(event) {
  const $select = $(event.currentTarget);
  const zoneId = $select.val();
  const $containers = $zonePricetypeContainers();
  const $selects = $selectsPricetypes($containers);

  const toShow = [];
  const toHide = [];

  $containers.each((index, el) => {
    if ($(el).attr('data-zone-no') == zoneId) {
      toShow.push(el);
    } else {
      toHide.push(el);
    }
  });


  $selects.val('0');
  $(toHide).hide();

  if (toShow.length) {
    if (arePricetypesVisible) {
      $(toShow).show();
    } else {
      // changing this up from slideDown() to show() to try
      // to fix mobile safari "resizing" issue
      // â€“ might no longer need to keep track of 'arePricetypesVisible'
      arePricetypesVisible = true;
      $(toShow).show();
    }
  } else {
    arePricetypesVisible = false;
  }

  updateBtnSubmitState();
}


function parseDataAttrs(el) {
  const dataAttrRegEx = /(?:^data-)(.*)/;
  const data = {};

  Array.from(el.attributes).forEach(attr => {
    const name = attr.name;
    const match = name.match(dataAttrRegEx);
    if (match !== null) {
      data[match[1]] = attr.value;
    }
  });
  return data;
}

function handleEvent(event) {
  event.preventDefault();

  $( ".js-mini-cal-popover" ).each(function( index, el ) {
      $(el).css("display", "none");
  });

  const el = event.currentTarget;

  const data = parseDataAttrs(el);

  showDialogBuyTickets(data);
}

function reloadDialog(updates = {}) {
  showDialogBuyTickets(Object.assign({}, currData, updates));
}

$(document).on('click', '#btn-dialog-buy-tickets--request-ada', _ => {
  reloadDialog({needs_accessible: 1});
});
$(document).on('click', '#btn-dialog-buy-tickets--request-standard', _ => {
  delete currData.needs_accessible;
  reloadDialog();
});

formHelper.addRule({
  form: '#form-dialog-buy-tickets--promo-code',
  status: {
    SUCCESS: reloadDialog
  }
});

$(_ => {
  const regex = /[^\d]/g;

  $('.js-ot-dialog-buy-tix-btn-inserter').each((index, el) => {

    const pieces = el.innerHTML.split(':');

    let perfOrPkgNo = pieces.length === 2 ? pieces[1] : pieces[0];
    perfOrPkgNo = perfOrPkgNo.replace(regex, '');

    if (perfOrPkgNo !== '') {
      const label = (pieces.length === 2 ? pieces[0] : 'Buy Tickets').trim();
      const $el = $(el);
      const mode = $el.attr('data-buy-tickets-mode');
      if (mode === MODE_SINGLE_TICKETS) {
        $el.attr('data-perf_no', perfOrPkgNo);
      } else {
        $el.attr('data-pkg_no', perfOrPkgNo);
      }

      $el.attr('data-auto-reserve', '1');
      $el.html(label);
      $el.removeClass('ot-inserter');
    }

  });
});